const InputAddon = (props) => <div className={'input-group configurator__input-wrapper'} style={{ display: 'table' }}>
  <input
    type={props.type}
    min={props.min}
    className={'form-control'}
    value={props.value}
    onChange={(e) => props.onChange(e.target.value)}
  />
  <span className={'configurator__input-addon input-group-addon'}>{props.addon}</span>
</div>

export default InputAddon
